export default {
    "logo rock content": "Redirect to Home",
    home: "Entrar na Home",
    "my account": "Entrar na minha conta",
    products: "Entrar nos produtos",
    wallet: "Entrar na carteira",
    financial: "Entrar no financeiro",
};
